import React, { useState } from 'react';
import { Form, Button, InputNumber, Typography } from 'antd';
import { LOW_BALANCE_ALERT_PRESETS, LOW_BALANCE_ALERT_DEFAULT } from 'constants/wallet';
import useTranslation from 'utils/hooks/useTranslation';
import { formatPresetAmount } from './helper';

import styles from './style.module.scss';

const LowBalanceAlert = ({ currencySymbol, form }) => {
  const { translateText } = useTranslation();
  const [selectedPreset, setSelectedPreset] = useState(LOW_BALANCE_ALERT_DEFAULT);

  const handlePresetClick = amount => {
    setSelectedPreset(amount);
    form.setFieldsValue({ lowBalanceOtherAmount: null });
  };

  const handleOtherAmountChange = value => {
    if (value !== null && value !== undefined && value !== '') {
      setSelectedPreset(null);
    }
  };

  return (
    <div className={styles.lowBalanceAlert}>
      <Typography.Title level={5} className={styles.sectionTitle}>
        {translateText('corporateAccounts.wallet.create.lowBalanceAlert.title')}
      </Typography.Title>
      <Typography.Paragraph className={styles.sectionDescription}>
        {translateText('corporateAccounts.wallet.create.lowBalanceAlert.description')}
      </Typography.Paragraph>
      <div className={styles.lowBalancePresets}>
        {LOW_BALANCE_ALERT_PRESETS.map(amount => (
          <Button
            key={amount}
            className={
              selectedPreset === amount
                ? `${styles.presetButton} ${styles.presetSelected}`
                : styles.presetButton
            }
            data-testid={`lowBalancePreset-${amount}`}
            onClick={() => handlePresetClick(amount)}
          >
            {formatPresetAmount(amount, currencySymbol)}
          </Button>
        ))}
        <Form.Item name="lowBalanceOtherAmount" noStyle>
          <InputNumber
            min={0}
            controls={false}
            placeholder={translateText(
              'corporateAccounts.wallet.create.lowBalanceAlert.otherAmount',
            )}
            className={styles.otherAmountInput}
            data-testid="lowBalanceOtherAmount"
            onChange={handleOtherAmountChange}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default LowBalanceAlert;
